"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PosVendor = void 0;
var PosVendor;
(function (PosVendor) {
    /**
     * Carrols (a.k.a. Xenial)
     */
    PosVendor["CARROLS"] = "CARROLS";
    /**
     * IMPORTANT: DO NOT USE THE "CONNECTOR" PosVendor!
     *
     * The "Connector" POS is represented as "PRODUCT_NUMBER."
     */
    PosVendor["CONNECTOR"] = "CONNECTOR";
    /**
     * National Cash Register (NCR) / and NCR Enterprise Platform (NEP)
     */
    PosVendor["NCR"] = "NCR";
    /**
     * Oracle Hospitality eCommerce Integration Cloud Service
     * also known as Oracle
     * also know as Micros
     */
    PosVendor["OHEICS"] = "OHEICS";
    /**
     * Used for Partner API to allow 3rd parties to integrate with us
     */
    PosVendor["PARTNER"] = "PARTNER";
    /**
     * Tim Horton's Connector (a.k.a Product Number)
     */
    PosVendor["PRODUCT_NUMBER"] = "PRODUCT_NUMBER";
    /**
     * rPOS / RBI POS (f.k.a. MediaWorks)
     */
    PosVendor["RPOS"] = "RPOS";
    PosVendor["SIMPLY_DELIVERY"] = "SIMPLY_DELIVERY";
    PosVendor["QDI"] = "QDI";
    PosVendor["QST"] = "QST";
    PosVendor["SICOM"] = "SICOM";
    PosVendor["TABLET"] = "TABLET";
})(PosVendor = exports.PosVendor || (exports.PosVendor = {}));
//# sourceMappingURL=pos-vendor.js.map